import script from "./BlockedPracticeFullExplanationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlockedPracticeFullExplanationModal.vue?vue&type=script&setup=true&lang=ts"

import "./BlockedPracticeFullExplanationModal.vue?vue&type=style&index=0&id=02cb2cac&scoped=true&lang=scss"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02cb2cac"]])

export default __exports__